module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAATNJREFUWIXtl91VwzAMRq85DFAmoCNkBDZgBUboCDABHaEb0A3oBjQTwAYNE3w8YE5Sn8TIf6cP8L05iaUbSZEV+NeF5aYLSSvgGVgX2ByAJ+fcMXmnpJ3q6N3q8ypYl7x5lp0QYKoblyigTyVdBHDODanG+M5/kq4znMR0yAUBQNLhp4rqMcUVq4EiSeokvfhP27ypSgQkrSWdvKm3GESzCDA2uQ54NUWiZg34FAyT5hSNRHWALAgLgDdaojOInBqwV/W8OmBTAjAAnwUAPbCdvdOgBh6C8B+La6CZ85oAM4W66LxVI/pgPJp74M50ulZOwUrS469hbwVgVdUUSNp7/tNFABiblDnsixORpHvSJ5vbxOejI9k+1ViOwhSk/0zMyzwdu/CCpA3lB842c6r+g/oC64DHsdcbctQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/logout.png
// module id = pQHd
// module chunks = 1